/* Jediné místo, kde strana poradce sahá na hypoteční dotazník.
 *
 * PROČ ADAPTÉR A NE api.get() rozházené po komponentách:
 *  - Kontrakt s backendem je na jednom místě. Když se routa přejmenuje,
 *    mění se jeden soubor, ne pět.
 *  - Odhalení citlivého údaje a plný export do banky jsou VLASTNÍ endpointy.
 *    Kdyby se plné rodné číslo vozilo v běžném detailu, dostalo by se do
 *    paměti prohlížeče i do devtools u každého otevření záložky. Takhle si o
 *    něj musí někdo výslovně říct a server si to může zaznamenat.
 *
 * NIC TU NEODESÍLÁ ZPRÁVY. Neexistuje funkce „poslat klientovi“ — odkaz se
 * jen vyrobí, poradce si ho zkopíruje a pošle sám. Je to záměr, ne opomenutí.
 */
import api from "@/lib/api";

const ZAKLAD = "/api/hypoteka/dotaznik";

/** Seznam dotazníků klienta (bez odpovědí — jen stavy a platnost odkazů). */
export async function nactiDotazniky(contactId) {
  const { data } = await api.get(ZAKLAD, { params: { contact_id: contactId } });
  /* Server může vrátit obálku i holé pole. Ne-pole NIKDY neprojde dál jako
     prázdný seznam bez upozornění — to by poradce četl jako „nic neposláno“. */
  const polozky = Array.isArray(data) ? data : data?.polozky;
  if (!Array.isArray(polozky)) throw new Error("neocekavana-odpoved");
  return polozky.filter(Boolean);
}

/**
 * Vyrobí nový odkaz. Vrací { id, url_path, plati_do }.
 * `url_path` skládá server (obsahuje token) — frontend si adresu NIKDY
 * neskládá sám z id klienta, jinak by šlo odkaz uhodnout.
 */
export async function vytvorOdkaz(contactId, platnostDnu) {
  const { data } = await api.post(ZAKLAD, { contact_id: contactId, platnost_dnu: platnostDnu });
  return data;
}

/** Zneplatní odkaz — po tomhle se formulář klientovi už neotevře. */
export async function zneplatniOdkaz(id) {
  const { data } = await api.post(`${ZAKLAD}/${id}/zneplatnit`);
  return data;
}

/** Detail k přečtení: definice sekcí + odpovědi s citlivými poli MASKOVANÝMI. */
export async function nactiDetail(id) {
  const { data } = await api.get(`${ZAKLAD}/${id}`);
  return data;
}

/**
 * Odhalí jednu citlivou hodnotu (rodné číslo, číslo dokladu, číslo účtu).
 * Vědomá akce poradce → vlastní endpoint, který si server zaznamená do auditu.
 */
export async function odhalPole(id, poleId) {
  const { data } = await api.get(`${ZAKLAD}/${id}/odhalit/${encodeURIComponent(poleId)}`);
  return data;
}

/**
 * Plné odpovědi pro export do banky (včetně rodných čísel).
 * Vlastní endpoint ze stejného důvodu jako odhalPole — banka bez rodného čísla
 * žádost nezpracuje, ale nesmí to být běžný stav obrazovky.
 */
export async function nactiPlny(id) {
  const { data } = await api.get(`${ZAKLAD}/${id}/plny`);
  return data;
}
